import {Component, ContentChildren, Input, OnInit, QueryList, ViewChildren} from '@angular/core';

@Component({
  selector: 'cmp-list',
  template: `<ul class="list-group" [class.list-group-flush]="isFlush">
  <ng-content></ng-content>
</ul>
`,
  styles: [``]
})
export class ListComponent implements OnInit {

  @Input() isFlush: boolean = false;


  constructor() {
  }

  ngOnInit() {
  }

}
